import { GetFragmentDto } from '@app/modules/fragments/fragment.types';
import { socialExport, webApi } from '@mi-front/api-clients';
import { QueriesView } from '@mi-front/ui';

import { SocialExportUploadPageContent } from './SocialExportUploadPageContent';
import { SocialExportUploadPageSkeleton } from './SocialExportUploadPageSkeleton';
import {
  type UseSocialExportUploadPageResult,
  useSocialExportUploadPage,
} from './useSocialExportUploadPage';

/** Wires async queries to the social export upload UI for a fragment and platform. */
export function SocialExportUploadPage() {
  const uploadPage: UseSocialExportUploadPageResult = useSocialExportUploadPage();

  return (
    <QueriesView<
      [
        GetFragmentDto,
        string,
        socialExport.SettingsGetConnection200,
        webApi.ListEditsVideoEditorEditsQueryResponse,
      ]
    >
      loader={<SocialExportUploadPageSkeleton />}
      queries={[
        uploadPage.fragmentQuery,
        uploadPage.mediaUrlQuery,
        uploadPage.settingsQuery,
        uploadPage.editsListQuery,
      ]}
    >
      {([fragment, mediaUrl, settings]) => (
        <SocialExportUploadPageContent
          fragment={fragment}
          fragmentMediaUrl={mediaUrl}
          defaultSettings={settings}
          platform={uploadPage.platform}
          selectedSource={uploadPage.selectedSource}
          onSelectedSourceChange={uploadPage.setSelectedSource}
          edits={uploadPage.edits}
          isFragmentSourceAllowed={uploadPage.isFragmentSourceAllowed}
          hasAvailableSources={uploadPage.hasAvailableSources}
          showMediaSelector={uploadPage.showMediaSelector}
          hasSelectedRenderedEdit={uploadPage.hasSelectedRenderedEdit}
          renderedVideoUrl={uploadPage.renderedVideoUrl}
          PublishForm={uploadPage.PublishForm}
          onUpload={(data) => uploadPage.handleUpload(fragment, data)}
        />
      )}
    </QueriesView>
  );
}
